import * as React from "react";
import { SVGProps } from "react";

const Dmarket = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2000 1948" {...props}>
    <defs>
      <linearGradient
        id="a"
        x1={83.62}
        x2={878.54}
        y1={947.07}
        y2={947.07}
        gradientTransform="matrix(1 0 0 -1 0 1923)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00ba96" />
        <stop offset={0.52} stopColor="#00d9af" />
        <stop offset={1} stopColor="#00d9af" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={1144.49}
        x2={2001.4}
        y1={948.99}
        y2={948.99}
        gradientTransform="matrix(1 0 0 -1 0 1923)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#008d85" />
        <stop offset={1} stopColor="#00ffe0" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={250.91}
        x2={1904.03}
        y1={949}
        y2={949}
        gradientTransform="matrix(1 0 0 -1 0 1923)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#008d94" />
        <stop offset={1} stopColor="#00ffe0" />
      </linearGradient>
      <linearGradient
        id="d"
        x2={794.89}
        y1={947.06}
        y2={947.06}
        gradientTransform="matrix(1 0 0 -1 0 1923)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#00ba96" />
        <stop offset={0.52} stopColor="#00d9af" />
        <stop offset={1} stopColor="#00faaf" />
      </linearGradient>
    </defs>
    <g data-name="Layer 2">
      <g data-name="Layer 1">
        <path
          fill="url(#a)"
          d="M857 890.24 625.08 489 389.28 83.76a168.38 168.38 0 0 0-54.57-56.49h-1.95a148.49 148.49 0 0 0-56.52 58.44L100.85 389.6a138.94 138.94 0 0 0 0 140.26l210.47 364.27c15.59 25.32 21.44 54.54 21.44 83.76a178.34 178.34 0 0 1-21.44 83.76L102.8 1422a138.94 138.94 0 0 0 0 140.26l175.39 303.89c13.64 23.38 33.13 44.8 56.52 58.44h2c23.39-13.64 40.93-33.12 54.57-56.49l233.86-405.18L857 1057.76a171 171 0 0 0 0-167.52Z"
          opacity={0.25}
          style={{
            isolation: "isolate",
          }}
        />
        <path
          fill="url(#b)"
          d="m1975.62 878.55-233.86-403.24-239.7-414.92a171.53 171.53 0 0 0-42.87-48.7C1449.44 3.9 1439.69 0 1428 0c-122.78 0-206.58 3.9-268.94 3.9-9.74 0-15.59 11.69-13.64 21.43l60.41 339c0 3.9 0 7.79-1.95 11.69-23.39 42.86-21.44 95.45 3.9 138.31l214.37 374c15.59 27.27 23.39 56.49 23.39 85.71s-7.8 58.44-23.39 85.71l-216.32 374c-25.33 42.86-25.33 95.45-3.9 138.31 2 3.9 2 7.79 2 11.69l-60.41 337c-2 9.74 3.9 21.43 13.64 21.43 56.52 0-23.39 5.84 276.73 5.84 5.85 0 13.64-2 19.49-3.9 21.44-7.79 35.08-33.12 46.77-54.54l239.71-416.87 231.91-403.24c37-58.47 37-130.53 3.9-190.92"
          opacity={0.25}
          style={{
            isolation: "isolate",
          }}
        />
        <path
          fill="url(#c)"
          d="M1880.13 890.24 1414.36 83.76C1385.13 33.12 1330.56 0 1270.15 0H338.61c-31.18 0-60.41 9.74-87.7 25.32v1.95a168.38 168.38 0 0 1 54.57 56.49L539.34 489c21.44-9.74 46.77-15.58 70.16-15.58h385.86c60.41 0 115 31.17 144.21 83.76l192.93 333.06c29.23 50.65 29.23 114.93 0 167.53l-192.93 333.11c-29.23 50.65-85.75 83.76-144.21 83.76H611.44a168.21 168.21 0 0 1-70.16-15.58l-233.85 405.18a168.38 168.38 0 0 1-54.57 56.49v2c25.33 15.58 56.52 25.32 87.7 25.32H1274c60.41 0 115-31.17 144.21-83.76L1884 1057.76c27.31-52.59 27.31-114.93-3.87-167.52"
        />
        <path
          fill="url(#d)"
          d="M771.25 890.24 539.34 489 305.48 83.76a168.38 168.38 0 0 0-54.57-56.49H249a148.49 148.49 0 0 0-56.52 58.44L19 387.65a138.94 138.94 0 0 0 0 140.26l210.47 364.27c15.59 25.32 21.44 54.54 21.44 83.76a178.34 178.34 0 0 1-21.44 83.76L19 1422a138.94 138.94 0 0 0 0 140.26l175.4 303.92c13.64 23.38 33.13 44.8 56.52 58.44h2c23.39-13.64 40.93-33.12 54.57-56.49L541.3 1463l231.9-401.29c29.23-56.54 29.23-118.88-1.95-171.47Z"
        />
      </g>
    </g>
  </svg>
);

export default Dmarket;
